/* BASE */
declare global {
  interface Window {
    _env_: any
  }
}
export const BASE_API_URL =
  window._env_.REACT_APP_BASE_API_URL ?? process.env.REACT_APP_BASE_API_URL
